"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios")); // import i18n from 'i18next';


var config_1 = require("../config");
/**
 * Create a new axios instance
 */


exports.ProdApi = axios_1.default.create({
  baseURL: config_1.CLASSROOMS_API[config_1.Environments.PRODUCTION],
  timeout: 30000,
  headers: {// Authorization: 'Bearer', // center token goes here! f62f901a72d73e30d1467a10508906ef
  }
});
/**
 * Create a new axios instance
 */

exports.StageApi = axios_1.default.create({
  baseURL: config_1.CLASSROOMS_API[config_1.Environments.STAGE],
  timeout: 30000,
  headers: {// Authorization: 'Bearer', // center token goes here! f62f901a72d73e30d1467a10508906ef
  }
});
/**
 * Create a new axios instance
 */

exports.LocalApi = axios_1.default.create({
  baseURL: config_1.CLASSROOMS_API[config_1.Environments.LOCAL],
  timeout: 30000,
  headers: {// Authorization: 'Bearer', // center token goes here! f62f901a72d73e30d1467a10508906ef
  }
});
/**
 * Create a new axios instance
 */

exports.CustomApi = function (customApiUrl) {
  return axios_1.default.create({
    baseURL: customApiUrl,
    timeout: 30000,
    headers: {// Authorization: 'Bearer', // center token goes here! f62f901a72d73e30d1467a10508906ef
    }
  });
};

exports.ProdApi.interceptors.response.use(function (res) {
  return res.data;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        console.error(error.response.data);
        break;

      case 422:
        console.error(error.response.data);
        break;

      case 500:
        console.error(error.response.data);
        break;

      default:
        console.error(error.response.data);
    }
  }

  if (error.code === 'ECONNABORTED') {// toast.error(i18n.t('validations:RESPONSE_ERRORS.TIMEOUT'), { autoClose: 5000 });
  }

  return Promise.reject(error);
});
exports.StageApi.interceptors.response.use(function (res) {
  return res.data;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        console.error(error.response.data);
        break;

      case 422:
        console.error(error.response.data);
        break;

      case 500:
        console.error(error.response.data);
        break;

      default:
        console.error(error.response.data);
    }
  }

  if (error.code === 'ECONNABORTED') {// toast.error(i18n.t('validations:RESPONSE_ERRORS.TIMEOUT'), { autoClose: 5000 });
  }

  return Promise.reject(error);
});
exports.LocalApi.interceptors.response.use(function (res) {
  return res.data;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        console.error(error.response.data);
        break;

      case 422:
        console.error(error.response.data);
        break;

      case 500:
        console.error(error.response.data);
        break;

      default:
        console.error(error.response.data);
    }
  }

  if (error.code === 'ECONNABORTED') {// toast.error(i18n.t('validations:RESPONSE_ERRORS.TIMEOUT'), { autoClose: 5000 });
  }

  return Promise.reject(error);
});
/**
 * Set authentication token
 */

exports.setAuthToken = function (token, api) {
  api.defaults.headers.common.Authorization = "Bearer " + token;
}; // export const localeFlag = () => `locale=${i18n.language}`;


exports.setParam = function (name, value) {
  return value ? "&" + name + "=" + value : '';
};